export const loginKey = 'login';
export const signupKey = 'signup';
export const logoutKey = 'logout';
export const getAccountByIdKey = 'getAccountById';
export const forgotPasswordKey = 'forgotPassword';
export const newPasswordKey = 'newPassword';
export const newPhoneKey = 'newPhone';
